import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faVolumeUp } from "@fortawesome/free-solid-svg-icons";
import * as dateUtils from 'app/utils/dateUtils';
import { useAudioManager } from './AudioManager';

interface AudioButtonProps {
  timeAudio: string;
  audioRef: React.RefObject<HTMLAudioElement>;
}

export const AudioButton = (props: AudioButtonProps) => {
  const { registerAndPlay } = useAudioManager();
  const { timeAudio, audioRef } = props;
  if (!timeAudio) return null;

  const handlePlay = () => {
    if (audioRef.current) {
      audioRef.current.currentTime = dateUtils.asSeconds(timeAudio);
      registerAndPlay(audioRef.current);
    }
  };

  return (
    <FontAwesomeIcon
      icon={faVolumeUp}
      onClick={handlePlay}
      className="text-size-md cursor-pointer ml-2 mt-2 text-info"
    />
  );
};
